(function()
{
	//Include classes
	var Application = include('springroll.Application');
	var Debug = include('springroll.Debug', false);

	/**
	 * Mixin for the Character animation
	 * @class Character
	 */
	var Character = function()
	{
		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		this.stop();
		this.framerate = 30;
		this._anim = null;
		this._onComplete = this._onComplete.bind(this);
	};

	//Prototype reference
	var p = Character.prototype;

	/**
	 * Play an animation 
	 * @method playAnimation
	 * @param {String|Object|Array} anim The animation to play
	 * @return {springroll.AnimatorTimeline} The animation timeline
	 */
	p.playAnimation = function(eventList, eventName)
	{
		this._anim = eventName;
		return this.app.animator.play(
			this,
			eventList,
			this._onComplete
		);
	};

	/**
	 * Stop any animation
	 * @method stopAnimation
	 */
	p.stopAnimation = function()
	{
		this.app.animator.stop(this);
	};

	/**
	 * Animation is completed
	 * @method onComplete
	 * @private
	 */
	p._onComplete = function()
	{
		var anim = this._anim;
		this._anim = null;
		this.emit(anim ? anim : 'animComplete');
	};

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		this.stopAnimation();
		this._anim = null;
		this._onComplete = null;
	};

	//Assign to namespace
	namespace('nature').Character = Character;
}());
